import { render } from "./Dining.vue?vue&type=template&id=7167d942"
import script from "./Dining.vue?vue&type=script&lang=js"
export * from "./Dining.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__